
// Debouncing from UnderscoreJS - but limited
// https://github.com/jashkenas/underscore
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
var debounce = function(func, wait, immediate) {
  var timeout, result;

  var later = function(context) {
    timeout = null;
    result = func.apply(context);
  };

  var debounced = function(args) {
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(later, wait);
      if (callNow) result = func.apply(this, args);
    } else {
      timeout = delay(later, wait);
    }

    return result;
  };

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
};

// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
var delay = function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null);
  }, wait);
};
